import { z } from 'zod'

export const requiredString = (message = 'Required') =>
  z.string({ required_error: message }).min(1, message)

export const passwordSchema = z
  .string({})
  .min(10, 'Must be at least 10 characters long')
  .regex(/[a-z]/i, 'Must contain some letters')
  .regex(/[0-9]/, 'Must contain some numbers')

/**
 * Function to create a ZodString method with trim
 * @returns a zod string with trim method
 */
export const trimmedString = () => z.string().trim()
